import { db } from '@/store/firebase'
import formsJSON from '@/../functions/shared/forms.json'
import formMedicalRecord from '@/../functions/shared/formMedicalRecord.json'
import formCustomization from '@/../functions/shared/formCustomization'

// Garante que o estado inicial é válido
let initialForms = typeof formsJSON === 'string' ? JSON.parse(formsJSON) : formsJSON

// Adiciona o formulário do prontuário ao array de componentes, se ainda não existir
if (initialForms && Array.isArray(initialForms.components)) {
  const exists = initialForms.components.some(f => f && f.key === 'prontuario')
  if (!exists) {
    initialForms.components.push(...formMedicalRecord)
  }
}

const state = {
  forms: initialForms,
  customizations: {},
  loading: false,
  error: null
}

const getters = {
  getCustomizedForms: (state) => {
    try {
      if (!state.forms) {
        console.warn('Forms não encontrado no state')
        return {}
      }
      // Usa a função centralizada para aplicar todas as customizações
      return formCustomization.applyAll(state.forms, state.customizations)
    } catch (error) {
      console.error('Erro no getCustomizedForms:', error)
      return state.forms || {}
    }
  },

  getFormByKey: (state, getters) => (formKey) => {
    try {
      if (!formKey) {
        console.warn('formKey não fornecida')
        return null
      }

      const customizedForms = getters.getCustomizedForms
      if (!customizedForms || !Array.isArray(customizedForms.components)) {
        console.warn('Formulários customizados não disponíveis')
        return null
      }

      const foundForm = customizedForms.components.find(form => form && form.key === formKey)
      return foundForm || null
    } catch (error) {
      console.error('Erro no getFormByKey:', error)
      return null
    }
  }
}

const mutations = {
  SET_CUSTOMIZATIONS (state, customizations) {
    // Garante que as customizações estão em um formato válido
    try {
      // Se for uma string, tenta fazer o parse para objeto
      if (typeof customizations === 'string') {
        state.customizations = JSON.parse(customizations)
      } else if (customizations && typeof customizations === 'object') {
        // Se já for um objeto, usa diretamente
        state.customizations = customizations
      } else {
        // Se não for string nem objeto, inicializa vazio
        state.customizations = {}
      }
    } catch (error) {
      console.error('Erro ao processar customizações:', error)
      state.customizations = {}
    }
  },

  SET_LOADING (state, loading) {
    state.loading = loading
  },

  SET_ERROR (state, error) {
    state.error = error
  }
}

const actions = {
  async loadFormCustomization ({ commit }, companyId) {
    try {
      commit('SET_LOADING', true)
      commit('SET_ERROR', null)

      const doc = await db.collection('formCustom').doc(companyId).get()

      if (doc.exists) {
        const data = doc.data()
        // Converte o JSON para um objeto JavaScript
        const customization = JSON.parse(JSON.stringify(data.customization || {}))
        commit('SET_CUSTOMIZATIONS', customization)
      } else {
        commit('SET_CUSTOMIZATIONS', {})
      }
    } catch (error) {
      console.error('Erro ao carregar customizações:', error)
      commit('SET_ERROR', 'Erro ao carregar customizações dos formulários')
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async saveFormCustomization ({ commit }, { companyId, customization }) {
    try {
      commit('SET_LOADING', true)
      commit('SET_ERROR', null)

      // Valida se o JSON é válido
      JSON.parse(JSON.stringify(customization))

      await db.collection('formCustom').doc(companyId).set({
        customization,
        updatedAt: new Date()
      }, { merge: true })

      commit('SET_CUSTOMIZATIONS', customization)
    } catch (error) {
      console.error('Erro ao salvar customizações:', error)
      commit('SET_ERROR', 'Erro ao salvar customizações dos formulários')
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/formCustomization.js